export default {
  SPF: {
    title: 'SPF',
    description: 'Seguro de Proteção Financeira',
  },
  PLUS: {
    title: 'Plus',
    description: 'Acordos com os bancos',
  },
};
